import { render } from "./ApartmentView.vue?vue&type=template&id=55f9e4d9&scoped=true"
import script from "./ApartmentView.vue?vue&type=script&lang=js"
export * from "./ApartmentView.vue?vue&type=script&lang=js"

import "./ApartmentView.vue?vue&type=style&index=0&id=55f9e4d9&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f9e4d9"]])

export default __exports__